<vn-page-matrix [content]="content | dsl | async" />
